export const serializeQueryParams = paramObj => {
  if (paramObj) {
    const queryParts = Object.keys(paramObj).flatMap((key) => {
      const value = paramObj[key]

      if (value === undefined || value === null) return []

      if (Array.isArray(value)) {
        return value
          .filter((v) => v !== undefined && v !== null)
          .map(
            (v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
          )
      }

      return [`${encodeURIComponent(key)}=${encodeURIComponent(value)}`]
    })

    if (queryParts.length === 0) return ''
    return `?${queryParts.join('&')}`
  }
  return ''
}
